import moment from 'moment';

import i18n from 'scripts/i18n/i18n';

// The shortened forms below rewrite moment's English output ("5 minutes ago" →
// "5m"); they only apply when moment is in the English locale. Other locales
// keep moment's localized phrasing.
function isEnglishLocale() {
  return moment.locale().startsWith('en');
}

export default class TimestampFormatter {
  constructor(timestamp) {
    this.moment = moment(timestamp);
  }

  full() {
    return this.moment.format('MMM D, YYYY h:mma');
  }

  // Absolute date + time, omitting the year for dates within the current year (e.g. "Jun 15, 2:46 PM"
  // vs "Mar 3, 2024, 9:12 AM"). Used by the "Detailed dates" agent preference in the conversation feed.
  absolute() {
    if (moment().isSame(this.moment, 'year')) {
      return this.moment.format('MMM D, h:mm A');
    }
    return this.moment.format('MMM D, YYYY, h:mm A');
  }

  relative() {
    if (moment().subtract(7, 'days').isBefore(this.moment)) {
      // between 7 days ago and now
      return this.ago();
    } else if (moment().startOf('year').isBefore(this.moment)) {
      // between start of year and 7 days ago
      return this.moment.format('MMM D');
    } else {
      // before start of this year
      return this.moment.format('MMM D, YYYY');
    }
  }

  ago() {
    if (moment().subtract(45, 'seconds').isBefore(this.moment) && moment().add(45, 'seconds').isAfter(this.moment)) {
      return i18n.t('just now');
    }
    if (!isEnglishLocale()) {
      return this.moment.fromNow();
    }
    return this.moment.fromNow().replace('minutes', 'mins');
  }

  shortenedAgo() {
    if (moment().subtract(45, 'seconds').isBefore(this.moment) && moment().add(45, 'seconds').isAfter(this.moment)) {
      return i18n.t('just now');
    }
    if (!isEnglishLocale()) {
      return this.moment.fromNow();
    }
    return this.moment
      .fromNow()
      .replace('a minute', '1m')
      .replace('an hour', '1h')
      .replace('a day', '1d')
      .replace(' seconds', 's')
      .replace(' minutes', 'm')
      .replace(' hours', 'h')
      .replace(' days', 'd');
  }
}
